import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
 
const styles = theme => ({
  root: {
    textAlign: "center",
    flex: 1
  },
  dots: {
    verticalAlign: "text-bottom",
    paddingBottom: 2,
    //fill: theme.palette.text.hint
    fill: "#f5f5f5"
  },
  bars: {
    verticalAlign: "text-bottom",
    paddingBottom: 1,
    //fill: theme.palette.text.hint
    fill: "#f5f5f5"
  },
  text: {
    display: "inline-flex",
    color: theme.palette.text.primary,
    fontFamily: "Roboto",
    fontSize: "1.25rem",
    fontWeight: 300, 
    paddingLeft: 12,
    paddingRight: 8 
  }
});

function Dots(props) {

  const { classes } = props;

  return(
      <svg viewBox="-50 -50 100 100" width={16} transform="rotate(22.5)" className={classes.dots}>
        <circle cx={-32} cy={-32} r={18} />
        <circle cx={32} cy={-32} r={18} />
        <circle cx={-32} cy={32} r={18} />
        <circle cx={32} cy={32} r={18} />
      </svg>
  );
}

function Bars(props) {

  const { classes } = props;

  return(
    <svg viewBox="0 0 84 72" width={22} className={classes.bars}>
      <rect x={2} y={4} width={44} height={18} />
      <rect x={32} y={28} width={52} height={18} />
      <rect x={14} y={52} width={48} height={18} />
    </svg>
  );
}

function Brand(props) {

  const { classes } = props;

  return (
    <div className={classes.root}>
      <Dots classes={classes}/>
      <div className={classes.text}>consilium</div>
      <Bars classes={classes}/>
    </div>
  );
}

Dots.propTypes = {
  classes: PropTypes.object
}

Bars.propTypes = {
  classes: PropTypes.object
}

Brand.propTypes = {
  classes: PropTypes.object
}

export default withStyles(styles)(Brand);
